module.exports = __webpack_public_path__ + "static/media/Background_splash_screen_mobile.c49ccc74.png";